type Path = string;
type Data = object;

const URL = "https://api.playg.eu";

export default class server {
  async post(path: Path, data?: Data) {
    try {
      const response = await fetch(`${URL}${path}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });

      const json = await response.json();
      const responseObj = {
        status: response.status,
        data: json,
      };

      if (response.status === 401 || response.status === 403) {
        window.location.replace("/login");
        return;
      }

      if (!response.ok) {
        alert(responseObj.data.message || json);
        return responseObj.data.message || json;
      }

      return responseObj;
    } catch (error) {
      throw new Error(`error: ${error}`);
    }
  }

  async put(path: Path, data: Data) {
    try {
      const response = await fetch(`${URL}${path}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        credentials: "include",
      });
      const json = await response.json();
      const responseObj = {
        status: response.status,
        data: json,
      };

      if (response.status === 401 || response.status === 403) {
        window.location.replace("/login");
        return;
      }

      if (!response.ok) {
        alert(responseObj.data.message || json);
        return responseObj.data.message || json;
      }

      return responseObj;
    } catch (error) {
      throw new Error(`error: ${error}`);
    }
  }

  async get(path: Path) {
    try {
      const response = await fetch(`${URL}${path}`, {
        credentials: "include",
      });
      const json = await response.json();
      const responseObj = {
        status: response.status,
        data: json,
      };

      if (response.status === 401 || response.status === 403) {
        window.location.replace("/login");
        return { status: response.status };
      }

      if (!response.ok) {
        alert(responseObj.data.message || json);
        return responseObj.data.message || json;
      }

      return responseObj;
    } catch (error) {
      throw new Error(`error: ${error}`);
    }
  }

  async delete(path: Path, data?: Data) {
    try {
      const response = await fetch(`${URL}${path}`, {
        method: "DELETE",
        credentials: "include",
      });
      const json = await response.json();
      const responseObj = {
        status: response.status,
        data: json,
      };

      if (response.status === 401 || response.status === 403) {
        window.location.replace("/login");
        return;
      }

      if (!response.ok) {
        alert(responseObj.data.message || json);
        return responseObj.data.message || json;
      }

      return responseObj;
    } catch (error) {
      throw new Error(`error: ${error}`);
    }
  }
}
